import React, { useState, useEffect } from "react";
import { getDevApplicationState, PaintMode } from "./devApplicationGlobal";
import { getDevEmitter, dev_event } from "./devEvents";

export const PaintingToolTab = () => {
  const [mode, setMode] = useState(0);
  const dev = getDevApplicationState();
  const [isEditting, setEditting] = useState(false);

  useEffect(() => {
    const handler = () => {
      // Default mode
      setMode(0);
      setEditting(true);
    };
    const handler2 = () => {
      setEditting(false);
    };
    getDevEmitter()?.addListener(dev_event.EDIT_LEVEL, handler);
    getDevEmitter()?.addListener(dev_event.SKIP_TO_LEVEL, handler2);
    return () => {
      getDevEmitter()?.removeListener(dev_event.EDIT_LEVEL, handler);
      getDevEmitter()?.removeListener(dev_event.SKIP_TO_LEVEL, handler2);
    };
  }, []);
  useEffect(() => {
    if (isEditting) {
      setTimeout(() => {
        dev?.changePaintMode(PaintMode.Select);
        setMode(2);
      }, 50);
    }
  }, [isEditting]);
  if (isEditting) {
    return (
      <ul className="paintTools active-buttons">
        <li
          className={mode === 0 ? "active" : ""}
          onClick={() => {
            if (mode !== 0) {
              dev?.changePaintMode(PaintMode.Pencil);
            }
            setMode(0);
          }}
        >
          Pencil
        </li>
        <li
          className={mode === 1 ? "active" : ""}
          onClick={() => {
            if (mode !== 1) {
              dev?.changePaintMode(PaintMode.Eraser);
            }
            setMode(1);
          }}
        >
          Eraser
        </li>
        <li
          className={mode === 2 ? "active" : ""}
          onClick={() => {
            if (mode !== 2) {
              dev?.changePaintMode(PaintMode.Select);
            }
            setMode(2);
          }}
        >
          Select
        </li>
      </ul>
    );
  } else {
    return <span>No edits in play mode</span>;
  }
};
